import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Bearer fallback (works alongside cookies for cross-origin reliability)
let bearer = localStorage.getItem("saa_token") || null;
export const setBearer = (t) => {
  bearer = t;
  if (t) localStorage.setItem("saa_token", t);
  else localStorage.removeItem("saa_token");
};

api.interceptors.request.use((config) => {
  if (bearer) {
    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${bearer}` };
  }
  return config;
});

export default api;
